import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Checkbox } from "@mui/material";

import { allWasteTypesIds } from "../../reducers/collectionYardDetailSettingsReducer";
import { RootState } from "../../store";
import { ColumnFilterProps, FilterOperator } from "../../types/filters";

export const AllWasteTypesFilter: React.FC<ColumnFilterProps> = ({
  fieldName,
  filterSelectorValue,
  filterUpdateAction,
  operator = FilterOperator.ArrayContains,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const options = allWasteTypesIds;
  const value = [
    ...((useSelector((state: RootState) => filterSelectorValue(state, fieldName))?.value as number[]) ?? []),
  ];

  return (
    <>
      {options.map((option) => (
        <div
          onClick={() => {
            if (!value.includes(option)) {
              value.push(option);
            } else {
              value.splice(value.indexOf(option), 1);
            }
            dispatch(
              filterUpdateAction({
                id: fieldName,
                name: fieldName,
                operator,
                value: [...value],
              })
            );
          }}
          key={option}
        >
          <Checkbox
            name={`allWasteTypes.${String(option)}`}
            style={{ paddingTop: 0, paddingBottom: 0 }}
            checked={value.includes(option)}
          />
          <label htmlFor={`allWasteTypes.${String(option)}`}>{t(`enums.allWasteTypes.${option}.short`)}</label>
        </div>
      ))}
    </>
  );
};
